var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewModuleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4af08e0a-8b33-41c3-89c6-d2622717152d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34.00098,
    viewBox: "0 0 34 34.00098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-f29fe3d1-d7b9-4e9c-afc2-c611604def61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33,34H1c-.55225,0-1-.44727-1-1V1C0,.44727,.44775,0,1,0H33c.55225,0,1,.44727,1,1V33c0,.55273-.44775,1-1,1Zm-31-2h30V2H2v30Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,12.66699H1c-.55225,0-1-.44727-1-1s.44775-1,1-1H33c.55225,0,1,.44727,1,1s-.44775,1-1,1Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,34.00098c-.55225,0-1-.44727-1-1V1c0-.55273,.44775-1,1-1s1,.44727,1,1V33.00098c0,.55273-.44775,1-1,1Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,23.33398H1c-.55225,0-1-.44727-1-1s.44775-1,1-1H33c.55225,0,1,.44727,1,1s-.44775,1-1,1Z",
    style: {
      fill: "#1a1a1a"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewModuleIcon);
export default __webpack_public_path__ + "static/media/viewModuleIcon.096d33b5dc4067b73f29b912b17370b4.svg";
export { ForwardRef as ReactComponent };